import { render } from "./verified-icon.vue.js?vue&type=template&id=63df02c8!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./verified-icon.vue?vue&type=template&id=63df02c8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__